/* istanbul ignore file */

import BasePage from '../../components/base-page/base-page';
import type { UiElement } from '../../../shared/ui-element/ui-element';
import Carousel from '../../components/carousel/carousel';

import breakpoints from '../../config/breakpoints';

import './ai-assistant.scss';

class AiAssistantPage extends BasePage {
  private reviewsCarousel: Carousel;

  ui = {
    reviewsCarousel: '.js-reviews-carousel',
  };

  uiCollections = {
    aiApps: '.js-ai-app',
  };

  events = {
    'click @uiCollections.aiApps': 'onAiAppClick',
  };

  onInit() {
    super.onInit();

    this.reviewsCarousel = new Carousel({
      rootElement: this.ui.reviewsCarousel,
      slidesPerPage: {
        [breakpoints.xs]: 1,
        [breakpoints.sm]: 2,
        [breakpoints.lg]: 3,
      },
    });
    this.reviewsCarousel.init();
  }

  onAiAppClick(e: Event) {
    const { id } = (e.currentTarget as HTMLElement).dataset;

    if (id) {
      window.open(`https://setapp.com/apps/${id}`);
    }
  }
}

export default AiAssistantPage;

(AiAssistantPage as UiElement).initOnDomLoaded();
